import { HttpHelper } from '../_commons/Helpers/HttpHelper';

const SetPassword = (token: string, newPassword: string): Promise<Response> => {
    return HttpHelper.PostJSON("api/PasswordReset/SetPassword", {
        token: token,
        newPassword: newPassword
    });
}

const ValidateToken = (token: string): Promise<Response> => {
    return HttpHelper.Get(`api/PasswordReset/ValidateToken?token=${encodeURIComponent(token)}`);
}

const RequestPasswordReset = (email: string): Promise<Response> => {
    return HttpHelper.PostJSON("api/PasswordReset/GenerateResetToken", {
        email: email
    });
}

export const PasswordResetService = {
    SetPassword,
    ValidateToken,
    RequestPasswordReset
}
